import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';
import { cpf } from 'cpf-cnpj-validator';

yup.addMethod(yup.string, 'cpf', function cpfTest() {
  return this.test(
    'is-cpf',
    () => 'CPF inválido',
    (value) => (value ? cpf.isValid(value) : true)
  );
});

const formatCpf = (value) => {
  let v = (value || '').replace(/\D/g, '');
  v = v.replace(/^(\d{3})(\d)/, '$1.$2');
  v = v.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
  v = v.replace(/\.(\d{3})(\d)/, '.$1-$2');
  v = v.replace(/(-\d{2})\d+?$/, '$1');
  return v;
};

const CPFField = ({ field, useFormRef, schema, label, ...props }) => {
  const { control } = useFormRef;
  const fieldSchema = schema ? yup.reach(schema, field) : null;

  return (
    <Controller
      name={field}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <TextField
          fullWidth
          inputRef={ref}
          label={fieldSchema?.spec?.label ?? label ?? 'CPF'}
          required={!!fieldSchema?.exclusiveTests?.required}
          error={!!error}
          helperText={error?.message}
          value={value ?? ''}
          onChange={(e) => {
            const masked = formatCpf(e.target.value);
            onChange(masked);
          }}
          onBlur={onBlur}
          InputLabelProps={{
            shrink: Boolean(value) || undefined,
            ...props.InputLabelProps,
          }}
          {...props}
        />
      )}
    />
  );
};

export default CPFField;
